<div class="main-content" style="display: none">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h3 style="color: green; font-weight: 600">
              Total Wiped Devices and Drives
            </h3>
          </div>
          <div
            class="card-body"
            style="
              border-top: 1px solid #eee;
              font-weight: 800;
              font-size: -webkit-xxx-large;
            "
          >
            <i class="material-icons" style="color: green"> description </i>
            {{ totalDiscs | number }}
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h3 style="color: red; font-weight: 600">Total Destroyed Devices and Drives</h3>
          </div>
          <div
            class="card-body"
            style="
              border-top: 1px solid #eee;
              font-weight: 800;
              font-size: -webkit-xxx-large;
            "
          >
            <i style="color: red" class="material-icons"> description </i>
            {{ totalDiscsDestroyed | number }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <button type="button" class="btn btn-primary" (click)="openModalRange()">
          Report By Range
        </button>
        <button type="button" style="margin-left: 20px;" class="btn btn-primary" (click)="DowloandReportHDD()">
          Download Report
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-rose card-header-icon">
            <div class="card-icon">
              <i class="material-icons">assignment</i>
            </div>
            <h4
              class="card-title"
              style="cursor: pointer"
              (click)="containerBySerialNumberSwitch()"
            >
              Search for a HDD or SSD<i class="material-icons"> toggle_on </i>
            </h4>
          </div>
          <div class="card-body">
            <div
              class="row"
              id="containerBySerialNumber"
              *ngIf="this.statusSerialNumberSwitch"
            >
              <div class="col-md-12">
                <form>
                  <div class="col-md-12">
                    <input
                      type="text"
                       [placeholder]="typesearch === 'po' ? 'Enter PO' : (typesearch === 'serialnumber' || typesearch === 'ddsn' ? 'Enter Serial Number' : 'Enter Inventory ID')"
                      class="form-control"
                      [(ngModel)]="advancedsearchtext"                      
                      name="advancedsearchtext"
                    />
                  </div>
                  <div class="row">
                    <div class="col-sm-5 checkbox-radios">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            [(ngModel)]="typesearch"
                            class="form-check-input"
                            type="radio"
                            name="typesearch"
                            value="serialnumber"
                            checked
                          />
                          Search by Serial Number
                          <span class="circle">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            [(ngModel)]="typesearch"
                            class="form-check-input"
                            type="radio"
                            name="typesearch"
                            value="inventoryid"
                            checked
                          />
                          EPS/SZA/BitRaser/PhoneCheck by ID:
                          <span class="circle">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            [(ngModel)]="typesearch"
                            (change)="changeTypeSearch()"
                            class="form-check-input"
                            type="radio"
                            name="typesearch"
                            value="po"
                          />
                          Search by PO
                          <span class="circle">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            [(ngModel)]="typesearch"
                            class="form-check-input"
                            type="radio"
                            name="typesearch"
                            value="ddsn"
                          />
                          Search for Destroyed Drives by Serial Number
                          <span class="circle">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                      <!--<div class="form-check">
                        <label class="form-check-label">
                          <input
                            [(ngModel)]="typesearch"
                            class="form-check-input"
                            type="radio"
                            name="typesearch"
                            value="securaze"
                            checked
                          />
                          Search in Securaze
                          <span class="circle">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>-->
                    </div>
                    <div class="col-sm-5 checkbox-radios">
                      <div
                        *ngIf="typesearch == 'serialnumber'"
                        class="form-check"
                      >
                        <label class="form-check-label">
                          <input
                            [(ngModel)]="deepSearch"
                            (change)="changeTypeSearch()"
                            type="radio"
                            name="deepSearch"
                            value="0"
                          />
                          Basic Search
                          <!-- <span class="form-check-sign">
                            <span class="check"></span>
                          </span> -->
                        </label>
                      </div>
                      <div
                        *ngIf="typesearch == 'serialnumber'"
                        class="form-check"
                      >
                        <label class="form-check-label">
                          <input
                            [(ngModel)]="deepSearch"
                            (change)="changeTypeSearch()"
                            type="radio"
                            name="deepSearch"
                            value="1"
                          />
                          Deep Search
                          <!-- <span class="form-check-sign">
                            <span class="check"></span>
                          </span> -->
                        </label>
                      </div>

                      <div
                        *ngIf="typesearch == 'serialnumber'"
                        class="form-check"
                      >
                        <label class="form-check-label">
                          <input
                            [(ngModel)]="deepSearch"
                            (change)="changeTypeSearch()"
                            type="radio"
                            name="deepSearch"
                            value="2"
                          />
                          Super Deep Search
                          <!-- <span class="form-check-sign">
                            <span class="check"></span>
                          </span> -->
                        </label>
 
                      </div>
                      <div
                        *ngIf="typesearch == 'serialnumber'"
                        class="form-check"
                      >
                        <label class="form-check-label">
                          <input
                            [(ngModel)]="deepSearch"
                            type="radio"
                            name="deepSearch"
                            value="3"
                          />
                          EPS PXE/SZA/BitRaser/PhoneCheck
                          <!-- <span class="form-check-sign">
                            <span class="check"></span>
                          </span> -->
                        </label>
 
                      </div>
                    </div>
                    <div class="col-sm-2 checkbox-radios">

                      <a *ngIf="typesearch == 'serialnumber'" class="btn btn-link btn-info btn-just-icon like" (click)="lockCheck = !lockCheck">
                        <i *ngIf="!lockCheck" class="fa fa-unlock-alt" aria-hidden="true"></i>
                        <i *ngIf="lockCheck" class="fa fa-lock" aria-hidden="true"></i>
                      </a>

                    </div>
                    <div
                      *ngIf="typesearch == 'serialnumber'"
                      class="col-sm-5 checkbox-radios"
                    >
                      <label
                        (click)="tooglefechas()"
                        style="cursor: pointer; margin-top: 10px"
                        class="bmd-label-floating"
                        ><i class="material-icons"> date_range </i> Filter by
                        Date</label
                      >
                      <div *ngIf="showDates">
                        <div style="margin-top: 0px" class="form-check">
                          <label class="form-check-label">
                            <input
                              [(ngModel)]="daysSearch"
                              class="form-check-input"
                              type="radio"
                              name="daysSearch"
                              value="0"
                              checked
                            />
                            No filter by date
                            <span class="circle">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              [(ngModel)]="daysSearch"
                              class="form-check-input"
                              type="radio"
                              name="daysSearch"
                              value="1"
                              checked
                            />
                            1 Day
                            <span class="circle">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              [(ngModel)]="daysSearch"
                              class="form-check-input"
                              type="radio"
                              name="daysSearch"
                              value="15"
                            />
                            15 days
                            <span class="circle">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              [(ngModel)]="daysSearch"
                              class="form-check-input"
                              type="radio"
                              name="daysSearch"
                              value="30"
                            />
                            30 days
                            <span class="circle">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              [(ngModel)]="daysSearch"
                              class="form-check-input"
                              type="radio"
                              name="daysSearch"
                              value="60"
                            />
                            60 days
                            <span class="circle">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    *ngIf="typesearch == 'serialnumber'"
                    class="btn btn-info"
                    (click)="searchBySN()"
                  >
                    Search
                  </button>

                  <button
                    *ngIf="typesearch == 'inventoryid'"
                    class="btn btn-info"
                    (click)="searchByInventoryID()"
                  >
                    Search
                  </button>

                  <button
                    *ngIf="typesearch == 'po'"
                    class="btn btn-info"
                    (click)="searchByPO()"
                  >
                    Search
                  </button>

                  <button
                    *ngIf="typesearch == 'ddsn'"
                    class="btn btn-info"
                    (click)="searchDDSN()"
                  >
                    Search
                  </button>

                  <button
                    *ngIf="typesearch == 'securaze'"
                    class="btn btn-info"
                    (click)="searchSecuraze()"
                  >
                    Search
                  </button>

                  <button
                    [disabled]="arrayExport.length == 0"
                    *ngIf="typesearch == 'po'"
                    class="btn btn-info"
                    (click)="generateErasureReport()"
                  >
                    Generate Data Erasure Report ({{ arrayExport.length }})
                  </button>
                </form>
                <app-inventory-attributes 
                  *ngIf="isEPSPXE" 
                  [deepSearch]="this.advancedsearchtext">
                </app-inventory-attributes>
                <div
                  id="showMsgSearching"
                  style="display: none"
                  class="alert alert-info"
                  role="alert"
                >
                  <i style="color: white" class="material-icons"> sync </i>
                  Please wait, searching in progress
                </div>
                <div
                  *ngIf="this.showMsgSearchingNotResults == 1"
                  id="showMsgSearchingNotResults"
                  class="alert alert-danger"
                  role="alert"
                >
                  <i style="color: white" class="material-icons"> cancel </i> No
                  records found, please try again
                </div>

                <div
                  *ngIf="this.typeMatch > 1"
                  id="showMsgSearchingNotExactResults"
                  class="alert alert-danger"
                  role="alert"
                >
                  <i class="material-icons text-white"> warning </i> This is not
                  an exact match
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div
                  *ngIf="alertWrongErasureMethod"
                  class="alert alert-danger"
                  role="alert"
                >
                  Wrong Erasure Method
                </div>
              </div>
              <div class="col-md-6">
                <div *ngIf="this.alertHoldBadHardDrives == 'Yes'">
                  <img style="width: 100px" src="/assets/img/stop.png" /> <br />
                </div>
                <div *ngIf="this.alertHoldBadHardDrives == 'No'">
                  <img style="width: 100px" src="/assets/img/faces/trash.png" />
                  <br />
                  <h4>Scrap</h4>
                </div>
              </div>
            </div>
            <div class="row" style="display: none" id="hdddsnresults">
              <div class="col-md-6" style="line-height: 30px">
                <h3>We found it!</h3>

                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Serial Number</div>
                  <div class="col-md-6">
                    {{ resultDDSN.SerialNumber }}
                  </div>
                </div>

              </div>
              <div class="col-md-6">
                <h1>PO# {{resultDDSN.po}}</h1>
                <div
                  class="container text-white bg-danger"
                  style="
                    padding: 80px;
                    text-align: center;
                    font-weight: 900;
                    font-size: -webkit-xxx-large;
                  "
                >
                  Destroyed
                </div>
              </div>
            </div>
            <div class="row" *ngIf="isSecuraze">
              <div class="card card-body">
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light">Type</div>
                  <div class="col-md-6">
                    {{ securazeType }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light">Name</div>
                  <div class="col-md-6">
                    {{ securazeName }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light">Vendor</div>
                  <div class="col-md-6">
                    {{ securazeVendor }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light">Serial Number</div>
                  <div class="col-md-6">
                    {{ securazeSerialNumber }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light">Chassis</div>
                  <div class="col-md-6">
                    {{ securazeChassis }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light">Container</div>
                  <div class="col-md-6">
                    {{ securazePO }}
                  </div>
                </div>
              </div>
            </div>           
            <div class="row" *ngIf="isSecuraze">
              <p style="text-align: center;">
                <a class="btn btn-primary" data-toggle="collapse" href="#collapseBatteries" role="button" aria-expanded="false" aria-controls="collapseBatteries" style="margin-right: 5px;" *ngIf="batteries.length > 0" (click)="collapse('Batteries')"> 
                  Batteries
                </a>
                <a class="btn btn-primary" data-toggle="collapse" href="#collapseDiscDrives" role="button" aria-expanded="false" aria-controls="collapseDiscDrives" style="margin-right: 5px;" *ngIf="disc_drives.length > 0" (click)="collapse('Disc')">
                  Disc Drives
                </a>
                <a class="btn btn-primary" data-toggle="collapse" href="#collapseGpus" role="button" aria-expanded="false" aria-controls="collapseGpus" style="margin-right: 5px;" *ngIf="gpus.length > 0" (click)="collapse('Gpus')">
                  Gpus
                </a>
                <a class="btn btn-primary" data-toggle="collapse" href="#collapseMemory" role="button" aria-expanded="false" aria-controls="collapseMemory" style="margin-right: 5px;" *ngIf="memory.length > 0" (click)="collapse('Memory')">
                  Memory
                </a>
                <a class="btn btn-primary" data-toggle="collapse" href="#collapseMotherboards" role="button" aria-expanded="false" aria-controls="collapseMotherboards" style="margin-right: 5px;" *ngIf="motherboards.length > 0" (click)="collapse('Motherboards')">
                  Motherboards
                </a>
                <a class="btn btn-primary" data-toggle="collapse" href="#collapseNetworkInterfaces" role="button" aria-expanded="false" aria-controls="collapseNetworkInterfaces" style="margin-right: 5px;" *ngIf="network_interfaces.length > 0" (click)="collapse('Network')"> 
                  Network Interfaces
                </a>
                <a class="btn btn-primary" data-toggle="collapse" href="#collapseProcessors" role="button" aria-expanded="false" aria-controls="collapseProcessors" style="margin-right: 5px;" *ngIf="processors.length > 0" (click)="collapse('Processors')">
                  Processors
                </a>
              </p>
              <div class="col-md-12 collapse" id="collapseBatteries" *ngIf="batteriesCollapse">
                <div class="card card-body" *ngFor="let battery of batteries; let i = index">
                  <a class="btn btn-primary" data-toggle="collapse" href="#collapseBatteries{{i}}" role="button" aria-expanded="false" aria-controls="collapseBatteries" style="margin-right: 5px;">
                    Battery # {{i+1}}
                  </a>

                  <div class="card card-body collapse" id="collapseBatteries{{i}}">

                    <p><strong>Battery # {{i+1}}</strong></p> 
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Battery Health</div>
                      <div class="col-md-6">
                        {{ battery.batteryhealth }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Battery Cycle Count</div>
                      <div class="col-md-6">
                        {{ battery.batterycyclecount }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Battery Design Capacity</div>
                      <div class="col-md-6">
                        {{ battery.batterydesigncapacity }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Battery Full Charge Capacity</div>
                      <div class="col-md-6">
                        {{ battery.batteryfullchargecapacity }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 collapse" id="collapseDiscDrives" *ngIf="disc_drivesCollapse" >
                <div class="card card-body" *ngFor="let disc of disc_drives; let i = index">

                  <a class="btn btn-primary" data-toggle="collapse" href="#collapseDiscDrives{{i}}" role="button" aria-expanded="false" aria-controls="collapseDiscDrives" style="margin-right: 5px;">
                    Disc # {{i+1}}
                  </a>

                  <div class="card card-body collapse" id="collapseDiscDrives{{i}}">

                    <p><strong>Disc # {{i+1}}</strong></p>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Model</div>
                      <div class="col-md-6">
                        {{ disc.model }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Serial Number</div>
                      <div class="col-md-6">
                        {{ disc.serialnumber }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">SizeGB</div>
                      <div class="col-md-6">
                        {{ disc.sizegb }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Vendor</div>
                      <div class="col-md-6">
                        {{ disc.vendor }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Type</div>
                      <div class="col-md-6">
                        {{ disc.type }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Wipe Result</div>
                      <div class="col-md-6">
                        {{ disc.wiperesult }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Wipe Method</div>
                      <div class="col-md-6">
                        {{ disc.wipemethod }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Reallocated Sectors</div>
                      <div class="col-md-6">
                        {{ disc.reallocatedsectors }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Wipe Started</div>
                      <div class="col-md-6">
                        {{ disc.wipestarted }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Wipe Status</div>
                      <div class="col-md-6">
                        {{ disc.wipestatus }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Wipe Finished</div>
                      <div class="col-md-6">
                        {{ disc.wipefinished }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Hpa</div>
                      <div class="col-md-6">
                        {{ disc.hpa }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Dco</div>
                      <div class="col-md-6">
                        {{ disc.dco }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Smart</div>
                      <div class="col-md-6">
                        {{ disc.smart }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Overall State</div>
                      <div class="col-md-6">
                        {{ disc.overallstate }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Power On Hours</div>
                      <div class="col-md-6">
                        {{ disc.poweronhours }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Pending Sectors</div>
                      <div class="col-md-6">
                        {{ disc.pendingsectors }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Uncorrectable Sectors</div>
                      <div class="col-md-6">
                        {{ disc.uncorrectablesectors }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Data Wipe Employee</div>
                      <div class="col-md-6">
                        {{ disc.datawipemployee }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Health</div>
                      <div class="col-md-6">
                        {{ disc.health }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 collapse" id="collapseGpus" *ngIf="gpusCollapse">
                <div class="card card-body" *ngFor="let gpu of gpus; let i = index">

                  <a class="btn btn-primary" data-toggle="collapse" href="#collapseGpus{{i}}" role="button" aria-expanded="false" aria-controls="collapseGpus" style="margin-right: 5px;">
                    GPU # {{i+1}}
                  </a>

                  <div class="card card-body collapse" id="collapseGpus{{i}}">

                    <p><strong>GPU # {{i+1}}</strong></p> 
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Vendor</div>
                      <div class="col-md-6">
                        {{ gpu.vendor }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Component Model</div>
                      <div class="col-md-6">
                        {{ gpu.componentmodel }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Serial Number</div>
                      <div class="col-md-6">
                        {{ gpu.serialnumber }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 collapse" id="collapseMemory" *ngIf="memoryCollapse">
                <div class="card card-body" *ngFor="let m of memory; let i = index">

                  <a class="btn btn-primary" data-toggle="collapse" href="#collapseMemory{{i}}" role="button" aria-expanded="false" aria-controls="collapseMemory" style="margin-right: 5px;" *ngIf="m.vendor !== '[Empty]'">
                    Memory # {{i+1}}
                  </a>

                  <a class="btn btn-danger" data-toggle="collapse" href="#collapseMemory{{i}}" role="button" aria-expanded="false" aria-controls="collapseMemory" style="margin-right: 5px;" *ngIf="m.vendor === '[Empty]'">
                    Memory # {{i+1}} - EMPTY
                  </a>

                  <div class="card card-body collapse" id="collapseMemory{{i}}">

                    <p><strong>Memory # {{i+1}}</strong></p> 
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Vendor</div>
                      <div class="col-md-6">
                        {{ m.vendor }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Component Model</div>
                      <div class="col-md-6">
                        {{ m.componentmodel }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Serial Number</div>
                      <div class="col-md-6">
                        {{ m.serialnumber }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Description</div>
                      <div class="col-md-6">
                        {{ m.description }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Size</div>
                      <div class="col-md-6">
                        {{ m.size }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Slot</div>
                      <div class="col-md-6">
                        {{ m.slot }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Ram Type</div>
                      <div class="col-md-6">
                        {{ m.ramtype }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 collapse" id="collapseMotherboards" *ngIf="motherboardsCollapse">
                <div class="card card-body" *ngFor="let motherboard of motherboards; let i = index">

                  <a class="btn btn-primary" data-toggle="collapse" href="#collapseMotherboards{{i}}" role="button" aria-expanded="false" aria-controls="collapseMotherboards" style="margin-right: 5px;">
                    Motherboard # {{i+1}}
                  </a>

                  <div class="card card-body collapse" id="collapseMotherboards{{i}}">

                    <p><strong>Motherboard # {{i+1}}</strong></p> 
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Vendor</div>
                      <div class="col-md-6">
                        {{ motherboard.vendor }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Component Model</div>
                      <div class="col-md-6">
                        {{ motherboard.componentmodel }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Serial Number</div>
                      <div class="col-md-6">
                        {{ motherboard.serialnumber }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Description</div>
                      <div class="col-md-6">
                        {{ motherboard.description }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 collapse" id="collapseNetworkInterfaces" *ngIf="network_interfacesCollapse">
                <div class="card card-body" *ngFor="let network of network_interfaces; let i = index">

                  <a class="btn btn-primary" data-toggle="collapse" href="#collapseNetworkInterfaces{{i}}" role="button" aria-expanded="false" aria-controls="collapseNetworkInterfaces" style="margin-right: 5px;">
                    Network Interfaces # {{i+1}}
                  </a>

                  <div class="card card-body collapse" id="collapseNetworkInterfaces{{i}}">

                    <p><strong>Network Interfaces # {{i+1}}</strong></p> 
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Vendor</div>
                      <div class="col-md-6">
                        {{ network.vendor }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Component Model</div>
                      <div class="col-md-6">
                        {{ network.componentmodel }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Serial Number</div>
                      <div class="col-md-6">
                        {{ network.serialnumber }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Description</div>
                      <div class="col-md-6">
                        {{ network.description }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 collapse" id="collapseProcessors" *ngIf="processorsCollapse">
                <div class="card card-body" *ngFor="let processor of processors; let i = index">

                  <a class="btn btn-primary" data-toggle="collapse" href="#collapseProcessors{{i}}" role="button" aria-expanded="false" aria-controls="collapseProcessors" style="margin-right: 5px;">
                    Processorses # {{i+1}}
                  </a>

                  <div class="card card-body collapse" id="collapseProcessors{{i}}">

                    <p><strong>Processors # {{i+1}}</strong></p> 
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Vendor</div>
                      <div class="col-md-6">
                        {{ processor.vendor }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Component Model</div>
                      <div class="col-md-6">
                        {{ processor.componentmodel }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Description</div>
                      <div class="col-md-6">
                        {{ processor.description }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Version</div>
                      <div class="col-md-6">
                        {{ processor.version }}
                      </div>
                    </div>
                    <div class="row" style="border-top: 1px solid #ccc">
                      <div class="col-md-6 bg-light">Short Name</div>
                      <div class="col-md-6">
                        {{ processor.shortname }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="display: none" id="hdresults">
              <div class="col-md-6" style="line-height: 30px">
                <h3>We found it!</h3>

                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Block Size</div>
                  <div class="col-md-6">
                    {{ responseHDSN.BlockSize }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Capacity</div>
                  <div class="col-md-6">
                    {{ responseHDSN.Capacity }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Erasure Method</div>
                  <div class="col-md-6">
                    {{ responseHDSN.ErasureMethod }}
                  </div>
                </div>

                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Erasure Results</div>
                  <div class="col-md-6">
                    {{ responseHDSN.ErasureResults }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Erasure Start Date</div>
                  <div class="col-md-6">
                    {{ responseHDSN.ErasureStartDate }}
                  </div>
                </div>

                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Erasure End Date</div>
                  <div class="col-md-6">
                    {{ responseHDSN.ErasureEndDate }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Form Factor</div>
                  <div class="col-md-6">
                    {{ responseHDSN.FormFactor }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Firmware</div>
                  <div class="col-md-6">
                    {{ responseHDSN.microcode }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Health Score</div>
                  <div class="col-md-6">
                    {{ responseHDSN.HealthScore }}
                  </div>
                </div>

                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Manufacturer</div>
                  <div class="col-md-6">
                    {{ responseHDSN.Manufacturer }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Model</div>
                  <div class="col-md-6">
                    {{ responseHDSN.Model }}
                  </div>
                </div>

                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Pending Bad Sectors</div>
                  <div class="col-md-6">
                    {{ responseHDSN.PendingBadSectors }}
                  </div>
                </div>

                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Power On Hours</div>
                  <div class="col-md-6">
                    {{ responseHDSN.PowerOnHours }}
                  </div>
                </div>

                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">RPM</div>
                  <div class="col-md-6">
                    {{ responseHDSN.RPM }}
                  </div>
                </div>

                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Reallocated Sectors</div>
                  <div class="col-md-6">
                    {{ responseHDSN.ReallocatedSectors }}
                  </div>
                </div>

                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Serial Number</div>
                  <div class="col-md-6">
                    {{ responseHDSN.SerialNumber }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Parent Info</div>
                  <div class="col-md-6">
                    {{ responseHDSN.ParentInfo }}
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #eee">
                  <div class="col-md-6 bg-light">Vendor</div>
                  <div class="col-md-6">
                    {{ responseHDSN.Vendor }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <h1>PO# {{ responseHDSN.PoNumber }}</h1>
                <div
                  class="container text-white"
                  style="
                       padding: 40px;
    text-align: center;
    font-weight: 900;
    font-size: -webkit-xxx-large;
    height: 200px;

                  "
                  [ngClass]="{
                    'bg-info':
                      this.responseHDSN.ErasureResults === 'PASSED' &&  (responseHDSN.grade === 'Grade E' || responseHDSN.grade === 'Grade E - SSDs'),
                    'bg-warning': this.responseHDSN.ErasureResults === 'PARTIAL',
                    'bg-naranja': (responseHDSN.grade === 'Grade D' || responseHDSN.grade === 'Grade D-'),
                    'bg-success':
                      this.responseHDSN.ErasureResults === 'PASSED' &&  responseHDSN.grade != 'Grade E - SSDs' &&  responseHDSN.grade != 'Grade D' &&  responseHDSN.grade != 'Grade D-' ||
                      this.responseHDSN.ErasureResults ===
                        'Secure Auto Passed!',
                    'bg-danger': this.responseHDSN.ErasureResults === 'FAILED' || this.responseHDSN.ErasureResults === 'FAILED (Modified)'
                  }"
                >
                  {{ responseHDSN.ErasureResults }} <br><br>
<br>                  <div>({{responseHDSN.grade}})</div>

                </div>
                <!--<div style="    font-size: 2rem;
    text-align: center;
    padding: 20px;">
                  ({{responseHDSN.grade}})
                </div>-->

                <div
                  class="row"
                  style="margin-top: 5px"
                  *ngFor="let row of responseHDSN.iqInfo"
                >
                  <div class="col-md-12 alert alert-info" role="alert">
                    Item Info in IQ
                  </div>
                  <div class="col-md-6 bg-light">ID</div>
                  <div class="col-md-6">
                    {{ row.id }}
                  </div>
                  <div class="col-md-6 bg-light">Category</div>
                  <div class="col-md-6">
                    {{ row.category }}
                  </div>
                  <div class="col-md-6 bg-light">Item number</div>
                  <div class="col-md-6">
                    {{ row.itemnumber }}
                  </div>
                  <div class="col-md-6 bg-light">Description</div>
                  <div class="col-md-6">
                    {{ row.description }}
                  </div>

                  <div class="col-md-6 bg-light">Mfgr</div>
                  <div class="col-md-6">
                    {{ row.mfgr }}
                  </div>
                </div>

                <div
                  class="row"
                  style="margin-top: 5px"
                  *ngIf="responseHDSN.SerialNumber_new">
                  <div class="col-md-12">
                    <button class="btn btn-danger btn-block" (click)="cleanSN()">
                      Clean Serial Number
                    </button>
                  </div>

                </div>
              </div>
            </div>

            <div
              id="poshowMsgSearching"
              style="display: none"
              class="alert alert-info"
              role="alert"
            >
              <i style="color: white" class="material-icons"> sync </i> Please
              wait, searching in progress
            </div>
            <div
              *ngIf="this.poshowMsgInfoResults == 1"
              id="poshowMsgInfoResults"
              class="alert alert-info"
              role="alert"
            >
              <i style="color: white" class="material-icons"> cancel </i> This
              element already exists in the report.
            </div>

            <div
              *ngIf="this.poshowMsgSearchingNotResults == 1"
              id="poshowMsgSearchingNotResults"
              class="alert alert-danger"
              role="alert"
            >
              <i style="color: white" class="material-icons"> cancel </i>
              {{ msgerrorpo }}
            </div>

            <div
              *ngIf="this.poshowMsgSearchingFailedResults == 1"
              id="qcshowMsgSearchingFailedResults"
              class="alert alert-warning"
              role="alert"
            >
              <i style="color: white" class="material-icons"> cancel </i>
              {{ msgerrorpo }}
            </div>
            <div class="row" style="display: none" id="hdporesults">
              <div class="col-md-12" style="line-height: 30px">
                <div class="row">
                  <div class="col-md-4">
                    <h3>Elements in PO # {{ this.posearchtext }}</h3>
                  </div>
                  <div class="col-md-4" style="text-align: right">
                    <h5 (click)="changeDataArray('ALL')" style="cursor: pointer;" >
                      Total Hard Drives in this PO:
                      {{ responsePOsearch_bkp.length }} &nbsp; &nbsp;
                     
                    </h5>
                     <h5 (click)="changeDataArray('PASSED')" style="cursor: pointer;" class="text-success">
                      Total Drives Passed:
                      {{ qtyPassed }} &nbsp; &nbsp;
                     
                    </h5>
                     <h5 (click)="changeDataArray('FAILED')" style="cursor: pointer;" class="text-danger">
                      Total Drives Failed:
                      {{ qtyFailed }} &nbsp; &nbsp;
                     
                    </h5>
                    <h5 (click)="changeDataArray('PARTIAL')" style="cursor: pointer;" class="text-warning">
                      Total Drives Partial:
                      {{ qtyPartial }} &nbsp; &nbsp;
                     
                    </h5>
                  </div>
                  <div style="    text-align: right;
    margin-top: 10%;" class="col-md-4">
                     <button class="btn btn-danger btn-sm" (click)="deletebulk()">
                        Remove Selected
                      </button>

                      &nbsp;

                      <button class="btn btn-info btn-sm" (click)="manualityAddDialog()">
                        Manually Add
                      </button>
                  </div>
                </div>

                <button [disabled]="!arrayExport.length" class="btn btn-link btn-default btn-just-icon" title="Clean Selected" (click)="cleanBulk()">
                  <i class="material-icons">cleaning_services</i>
                </button>
                Selected items: {{ arrayExport.length }}

                <!-- <div class="row">
                  <div class="col-12">
                    <dinamic-table
                      [id]="'searchbypotable'"
                      [data]="daclickosearch"
                      [frontpaginate]="true"
                      (action_button)="action($event)"
                      [bulk]="bulk"
                      [cleanbulk]="true"
                    ></dinamic-table>
                  </div>
                </div> -->

                <div class="material-datatables">
                  <table id="exampleTable" class="table table-striped table-no-bordered table-hover" cellspacing="0"
                    width="100%" style="width:100%">

                    <thead>
                      <tr>
                        <th class="disabled-sorting no-sort">
                          <a class="btn btn-link btn-primary btn-just-icon" (click)="selectAll()">
                            <i class="fa {{ checkAll() ? 'fa-check-square' : 'fa-square-o' }}" aria-hidden="true"></i>
                          </a>
                        </th>
                        <th> <b> Manufacturer </b> </th>
                        <th> <b> Model </b> </th>
                        <th> <b> Serial Number </b> </th>
                        <th> <b> Serial Number New </b> </th>
                        <th> <b> Results </b> </th>
                        <th> <b> Grade </b> </th>
                        <th> <b> PO </b> </th>
                        <th> <b> Parent Info </b> </th>
                        <th class="disabled-sorting no-sort" style="text-align: right;"> <b>Actions</b> </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr *ngFor="let row of this.responsePOsearch">
                        <td>
                          <a class="btn btn-link btn-info btn-just-icon" (click)="check(row.id)">
                            <i class="fa {{isCheck(row.id) ? 'fa-check-square' : 'fa-square-o'}}" aria-hidden="true"></i>
                          </a>
                        </td>
                        <td>{{row.Manufacturer}}</td>
                        <td>{{row.Model}}</td>
                        <td>{{row.SerialNumber}}</td>
                        <td>{{row.SerialNumber_new}}</td>
                        <td class="bg-success text-white"
                        [ngClass]="{
                          'bg-success':
                            row.ErasureResults === 'PASSED' ||
                            row.ErasureResults === 'Secure Auto Passed!',
                            'bg-danger': (row.ErasureResults === 'FAILED' || row.ErasureResults === 'FAILED (Modified)'),
                            'bg-warning': row.ErasureResults === 'PARTIAL'
                          }">
                          {{ row.ErasureResults }}
                        </td>
                        <td>{{row.grade}}</td>
                        <td>{{ row.PoNumber }}</td>
                        <td>{{row.ParentInfo}}</td>
                        <td style="text-align: right;">

                          <a class="btn btn-link btn-danger btn-just-icon like" (click)="delete(row.id)">
                        <i
                          (click)="delete(row.id)"
                          class="material-icons text-danger"
                        >
                          delete
                        </i>
                      </a>

                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>

                <!-- <div class="row">
                  <div class="col-md-1 bg-light">
                    <input
                      type="checkbox"
                      name="select_all"
                      value="1"
                      id="example-select-all"
                    />
                  </div>
                  <div class="col-md-2 bg-light">Manufacturer</div>
                  <div class="col-md-2 bg-light">Model</div>
                  <div class="col-md-2 bg-light">Serial Number</div>
                  <div class="col-md-2 bg-light">Results</div>
                  <div class="col-md-2 bg-light">PO</div>
                  <div class="col-md-1 bg-light">Actions</div>
                </div> -->
                <!-- <div class="tbody">
                  <div
                    class="row"
                    *ngFor="let row of this.responsePOsearch"
                    style="border-top: 1px solid #eee"
                  >
                    <div class="col-md-1">
                      <input
                        class="checkingitem"
                        id="{{ row.id }}"
                        type="checkbox"
                        name="id[]"
                        value=""
                        [disabled]="row.ErasureResults === 'PARTIAL'"
                      />
                    </div>
                    <div class="col-md-2">
                      {{ row.Manufacturer }}
                    </div>
                    <div class="col-md-2">
                      {{ row.Model }}
                    </div>
                    <div class="col-md-2">
                      {{ row.SerialNumber }}
                    </div>
                    <div
                      class="col-md-2 bg-success text-white"
                      [ngClass]="{
                        'bg-success':
                          row.ErasureResults === 'PASSED' ||
                          row.ErasureResults === 'Secure Auto Passed!',
                        'bg-danger': row.ErasureResults === 'FAILED',
                        'bg-warning': row.ErasureResults === 'PARTIAL'
                      }"
                    >
                      {{ row.ErasureResults }}
                    </div>
                    <div class="col-md-2" style="font-weight: bold">
                      {{ row.PoNumber }}
                    </div>
                    <div class="col-md-1">
                      <a class="btn btn-link btn-danger btn-just-icon like" (click)="delete(row.id)">
                        <i
                          (click)="delete(row.id)"
                          class="material-icons text-danger"
                        >
                          delete
                        </i>
                      </a>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">

      <div class="row" style="display: none">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header card-header-rose card-header-icon">
              <div class="card-icon">
                <i class="material-icons">assignment</i>
              </div>
              <h4
                style="cursor: pointer"
                class="card-title"
                (click)="containerByQC()"
              >
                QC Inspection <i class="material-icons"> toggle_on </i>
              </h4>
            </div>
            <div class="card-body">
              <div class="row" *ngIf="statusContainerByQC">
                <div class="col-md-12">
                  <form>
                    <input
                      type="text"
                      placeholder="Enter Serial Number"
                      class="form-control"
                      [(ngModel)]="this.qcearchtext"
                      name="advancedsearchtext"
                    />

                    <button class="btn btn-info" (click)="searchQCInspection()">
                      Search
                    </button>
                    <button class="btn btn-success" (click)="showManually()">
                      Add Manually
                    </button>
                  </form>

                  <form *ngIf="this.qcShowAddManually">
                    <div class="col-md-6">
                      <input
                        type="text"
                        placeholder="Manufacturer"
                        class="form-control"
                        [(ngModel)]="this.qcManuallyManufacturer"
                        name="advancedsearchtext"
                      />
                    </div>
                    <div class="col-md-6">
                      <input
                        type="text"
                        placeholder="Model"
                        class="form-control"
                        [(ngModel)]="this.qcManuallyModel"
                        name="advancedsearchtext"
                      />
                    </div>
                    <div class="col-md-6">
                      <input
                        type="text"
                        placeholder="SerialNumber"
                        class="form-control"
                        [(ngModel)]="this.qcManuallySerialNumber"
                        name="advancedsearchtext"
                      />
                    </div>
                    <div class="col-md-6">
                      <input
                        type="text"
                        placeholder="PoNumber"
                        class="form-control"
                        [(ngModel)]="this.qcManuallyPoNumber"
                        name="advancedsearchtext"
                      />
                    </div>

                    <button class="btn btn-success" (click)="AddQCManually()">
                      Add To Report
                    </button>
                  </form>

                  <div
                    id="qcshowMsgSearching"
                    style="display: none"
                    class="alert alert-info"
                    role="alert"
                  >
                    <i style="color: white" class="material-icons"> sync </i>
                    Please wait, searching in progress
                  </div>
                  <div
                    *ngIf="this.qcshowMsgInfoResults == 1"
                    id="qcshowMsgInfoResults"
                    class="alert alert-info"
                    role="alert"
                  >
                    <i style="color: white" class="material-icons"> cancel </i>
                    This element already exists in the report.
                  </div>

                  <div
                    *ngIf="this.qcshowMsgSearchingNotResults == 1"
                    id="qcshowMsgSearchingNotResults"
                    class="alert alert-danger"
                    role="alert"
                  >
                    <i style="color: white" class="material-icons"> cancel </i>
                    {{ msgerrorqc }}
                  </div>

                  <div
                    *ngIf="this.qcshowMsgSearchingFailedResults == 1"
                    id="qcshowMsgSearchingFailedResults"
                    class="alert alert-warning"
                    role="alert"
                  >
                    <i style="color: white" class="material-icons"> cancel </i>
                    {{ msgerrorqc }}
                  </div>
                </div>
              </div>
              <div class="row" style="display: none" id="qchdresults">
                <div class="col-md-12" style="line-height: 30px">
                  <h3>Elements for QC Report</h3>

                  <div class="row">
                    <div class="col-md-2 bg-light">Manufacturer</div>
                    <div class="col-md-2 bg-light">Model</div>
                    <div class="col-md-2 bg-light">Serial Number</div>
                    <div class="col-md-2 bg-light">Results</div>
                    <div class="col-md-2 bg-light">PO</div>
                    <div class="col-md-2 bg-light">Actions</div>
                  </div>
                  <div
                    class="row"
                    *ngFor="let row of this.responseQCInspection"
                    style="border-top: 1px solid #eee"
                  >
                    <div class="col-md-2">
                      {{ row.Manufacturer }}
                    </div>
                    <div class="col-md-2">
                      {{ row.Model }}
                    </div>
                    <div class="col-md-2">
                      {{ row.SerialNumber }}
                    </div>
                    <div class="col-md-2 bg-success text-white">
                      {{ row.ErasureResults }}
                    </div>
                    <div class="col-md-2" style="font-weight: bold">
                      {{ row.PoNumber }}
                    </div>
                    <div class="col-md-2">
                      <i
                        (click)="removeElementFromReportTable(row.id)"
                        class="material-icons text-danger"
                      >
                        delete
                      </i>
                    </div>
                  </div>
                </div>
              </div>
              <button
                *ngIf="this.responseQCInspection.length > 0"
                class="btn btn-success"
                (click)="generateReport()"
              >
                Generate Report
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--<div class="row">
        <div class="col-md-12">
          <app-physicaldestruction></app-physicaldestruction>
        </div>
      </div>-->

      <div class="row">
        <div class="col-md-12">
          <app-linktomaster></app-linktomaster>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <app-searchforhddlinktomaster></app-searchforhddlinktomaster>
        </div>
      </div>

      <div class="row" id="showStats">
        <div class="col-md-6">
          <div class="card card-chart">
            <div
              class="card-header card-header-rose"
              data-header-animation="true"
            >
              <div class="ct-chart" id="websiteViewsChart"></div>
            </div>
            <div class="card-body">
              <div class="card-actions"></div>
              <h4 class="card-title">HD by brand</h4>
              <p class="card-category">HD wipings by brand</p>
            </div>
            <div class="card-footer">
              <div class="stats">
                <i class="material-icons">access_time</i> update 2 hrs ago
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-chart">
            <div
              class="card-header card-header-success"
              data-header-animation="true"
            >
              <div class="ct-chart" id="dailySalesChart"></div>
            </div>
            <div class="card-body">
              <div class="card-actions"></div>
              <h4 class="card-title">HD Wiping Status</h4>
              <p class="card-category">HD Wiping Status</p>
            </div>
            <div class="card-footer">
              <div class="stats">
                <i class="material-icons">access_time</i> update few minutes ago
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalEPSSZE" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">

            <div class="modal-header">
              <h4 class="modal-title" id="modal-title">Select</h4>
            </div>
            <div class="modal-body">
              <button type="button" class="btn btn-success" (click)="chooseEPSSZE('securaze')">   Securaze
              </button>
              &nbsp;&nbsp;
              <button type="button" class="btn btn-success" (click)="chooseEPSSZE('epspxe')">   EPS PXE
              </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal de Bootstrap -->
<div class="modal fade" id="dateRangeModal" tabindex="-1" aria-labelledby="dateRangeModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="dateRangeModalLabel">Select Range</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="mb-3">
            <label for="startDate" class="form-label">From</label>
            <input type="date" id="startDate" class="form-control" [(ngModel)]="startDate" name="startDate">
          </div>
          <div class="mb-3">
            <label for="endDate" class="form-label">To</label>
            <input type="date" id="endDate" class="form-control" [(ngModel)]="endDate" name="endDate">
          </div>
        </form>
      </div>
      <div class="modal-footer">
        
        <button
            *ngIf="stateDate " 
            type="button" 
            class="btn btn-secondary" 
            (click)="resetData()" 
            data-bs-dismiss="modal">Reset</button>
        &nbsp;&nbsp;
        <button type="button" class="btn btn-primary" (click)="generateReportByRange()" [disabled]="startDate === '' || endDate === '' || loadingRange">
          <i
            *ngIf="loadingRange"
            class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
          ></i>
          Generate Report
        </button>
      </div>
    </div>
  </div>
</div>